<idt-common-styles-render
  *ngIf="settings"
  [styles]="settings.styles">

  <table
    [class.sticky-column-table]="isFirstColumnSticky"
    *ngIf="tableContent.length > 0">
    <thead [class.sticky-header]="isFirstRowSticky">
    <th
      *ngFor="let field of tableContent[0]; let i = index; trackBy: trackByIndex"
      [class.sticky-column]="i === 0 && isFirstColumnSticky">
      {{ field.columnName }}
    </th>
    </thead>

    <tbody>
    <tr *ngFor="let row of tableContent; let i = index; trackBy: trackByIndex">
      <td
        *ngFor="let field of row; let i = index; trackBy: trackByIndex"
        [class.sticky-column]="i === 0 && isFirstColumnSticky">
        {{ field.value }}
      </td>
    </tr>
    </tbody>
  </table>

</idt-common-styles-render>
